import { render, staticRenderFns } from "./RefundTransDetails.vue?vue&type=template&id=5867edf4&scoped=true"
import script from "./RefundTransDetails.vue?vue&type=script&lang=js"
export * from "./RefundTransDetails.vue?vue&type=script&lang=js"
import style0 from "./RefundTransDetails.vue?vue&type=style&index=0&id=5867edf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867edf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5867edf4')) {
      api.createRecord('5867edf4', component.options)
    } else {
      api.reload('5867edf4', component.options)
    }
    module.hot.accept("./RefundTransDetails.vue?vue&type=template&id=5867edf4&scoped=true", function () {
      api.rerender('5867edf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data-agent/components/RefundTransDetails.vue"
export default component.exports